export const HEAT_FEATURE_STRINGS = {
  inputPlaceholder: 'Enter Location',
  heatherTitle: 'What type of heating source do you have?',
  furnaceLocationTitle: 'Where is the furnace located?',
};
